<script lang="ts">
import { MyAccount } from "@/dashboard/my-account/my-account.ts";
export default MyAccount;
</script>

<template>
    <div class="dashboard">
        <dashboard-sidebar />
        <div class="dashboard__content">
            <div class="row m-0">
                <h3 class="h3 dashboard__title">
                    <i18n-t keypath="dashboard.myAccount" />
                </h3>
            </div>
            <div class="row m-0">
                <div class="account__container">
                    <div class="account__btn-container">
                        <router-link
                            to="/auth/my-carconnex/my-account/contact-info"
                            custom
                            v-slot="{ navigate }"
                        >
                            <div
                                class="btn account__btn"
                                :class="{
                                    'is-active': tabActivity === myAccountTab.contact,
                                }"
                                id="contact"
                                data-value="1"
                                @click="navigate"
                            >
                                <i18n-t
                                    keypath="dashboard.myAccountComponent.contactInfo"
                                />
                            </div>
                        </router-link>
                        <router-link
                            to="/auth/my-carconnex/my-account/change-password"
                            custom
                            v-slot="{ navigate }"
                        >
                            <div
                                class="btn account__btn"
                                :class="{
                                    'is-active':
                                        tabActivity === myAccountTab.changePassword,
                                }"
                                id="documents"
                                data-value="3"
                                @click="navigate"
                            >
                                <i18n-t
                                    keypath="dashboard.myAccountComponent.changePassword"
                                />
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="account__tabs">
                    <contact-info v-if="tabActivity === myAccountTab.contact" />
                    <change-password v-if="tabActivity === myAccountTab.changePassword" />
                </div>
            </div>
        </div>
    </div>
</template>
